import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

const ErrorDialog = function ErrorDialog({ error = null, handleRetry = null }) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  const errorMessage = (err) => {
    if (typeof err === 'string') {
      return err;
    }
    if (err && Object.prototype.hasOwnProperty.call(err, 'response')) {
      if (typeof err?.response?.data === 'string') {
        return err?.response?.data;
      }
      return err?.response?.data?.Message;
    }
    return null;
  };

  useEffect(() => {
    setOpen(error);
  }, [error]);

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Dialog open={Boolean(open)}>
      <DialogTitle
        sx={{
          width: '20vw',
          display: 'flex',
          gap: 2,
          alignItems: 'center',
        }}
      >
        <ErrorOutlineOutlinedIcon sx={{ color: 'error.main' }} size="large" />
        <Typography variant="h5">{intl.messages.ERROR}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2">{intl.messages.MESSAGE}:</Typography>
        <DialogContentText sx={{ padding: '8px' }}>
          {typeof error !== 'string' &&
            error &&
            Object.prototype.hasOwnProperty.call(error, 'response') && (
              <Typography color="error" gutterBottom>
                {`${error?.response?.status} - ${error?.response?.statusText}`}
              </Typography>
            )}
          {React.isValidElement(error) ? (
            error
          ) : (
            <Typography gutterBottom>
              {errorMessage(error) || intl.messages.MESSAGE_UNAVAILABLE}
            </Typography>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {handleRetry !== null && (
          <Button variant="outlined" onClick={handleRetry} color="error">
            {intl.messages.RETRY}
          </Button>
        )}
        <Button variant="contained" onClick={closeDialog} color="error">
          {intl.messages.CLOSE}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
